<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{ $t("modal.station_config.schedules.copy_station") }}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>

      <div class="component-modal__item-detail">
        <ul>
          <template v-for="key in Object.keys(modelProps)" :key="key">
            <li v-if="key != 'id'">
              <strong>{{ $t(`modal.common.delete.props.${key}`) }}</strong> : {{getStation(props[key])}}
            </li>  
          </template>
        </ul> 
      </div>

      <div class="component-modal__row">
        <label for="code">{{$t("modal.station_config.schedules.station_to")}}
          <small v-if="model.stationIdTo.length == 0 && invalidForm" class="pill-required">* {{ $t("modal.common.required") }}</small>
          <small v-else>*</small>
        </label>
        <div class="component-modal__row">
          <template v-for="station in listStations" :key="station.id">
            <div class="component-modal-checkbox" v-if="station.id != model.stationId">
              <label :for="station.id">
                <input type="checkbox" :name="station.id" :id="station.id" :value="station.id" v-model="model.stationIdTo">
                {{ station.name }}
              </label>
            </div>
          </template>
        </div>
      </div>

      <div class="component-modal__row">
        <label>{{ $t("modal.station_config.schedules.items_to_copy") }}
          <small v-if="!(model.copyCommercialBreaks || model.copyShows) && invalidForm" class="pill-required">* {{ $t("modal.common.required") }}</small>
          <small v-else>*</small>
        </label>
        <div class="component-modal-checkbox">
          <label>
            <input type="checkbox" v-model="model.copyCommercialBreaks">
            {{ $t("modal.station_config.schedules.schedules") }}  
          </label>
        </div>
        <div class="component-modal-checkbox">
          <label for="allow">
            <input type="checkbox" v-model="model.copyShows">
            {{ $t("modal.station_config.schedules.program") }}  
          </label>
        </div>
      </div>
    
      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ $t("modal.copy") }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <!-- Alert validation -->
      <div class="component-modal__row" v-if="invalidForm">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          {{$t("modal.station_config.schedules.checkFields")}}
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';

export default {
  setup() {
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    const modelProps = ref({});
    const invalidForm = ref(false);
    const model = ref({
      stationId: 0,
      stationIdTo: [],
      copyCommercialBreaks: true,
      copyShows: true
    });
    
    onMounted(() => {
      if (props.value) {
        modelProps.value = Object.assign({}, props.value);
        model.value.stationId = modelProps.value.stationId;
      }
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      invalidForm.value = false;
    }

    async function saveAndClose() {
      if (model.value.stationIdTo.length > 0 && (model.value.copyCommercialBreaks || model.value.copyShows)) {
        try {
          await store.dispatch('schedule_copyStation', model.value);
          closeModal();
        } catch (error) {
          console.error(error);
        }
      } else {
        invalidForm.value = true;
      }
    }

    function getStation(id) {
      const listStations = store.getters.station_stations({code: '', name: ''});
      const station = listStations.find(station => station.id == id);
      return station.name;
    }

    return {
      props,
      modelProps,
      listStations,
      model,
      invalidForm,
      saveAndClose,
      closeModal,
      getStation
    }
  }
};
</script>